export default {
  // 本体状态
  statusTitle: '本体状态',
  statusNoData: '暂无数据',
  statusSn: 'SN：',
  statusSelfCheck: '自检状态：',
  statusInTask: '是否在任务中：',
  statusBattery: '剩余电量',
  statusCharging: '充电中',
  statusNotCharging: '未充电',
  statusVoltage: '电压',
  statusBatteryTemp: '电池温度',
  statusCycle: '循环',
  statusTelemetry: '遥测',
  statusHostTemp: '边缘主机温度',
  statusForwardSpeed: '前进速度',
  statusChassis: '底盘状态',
  statusRuntime: '采集组件运行时长',
  statusMotion: '运动反馈',
  statusStrafeSpeed: '横移速度',
  statusAngularSpeed: '角速度',
  statusControllerStopped: '控制器已停止',
  statusNav: '导航状态',
  statusNavPhase: '导航阶段',
  statusTargetStation: '目标站点',
  statusPose: '当前位姿',
  statusYaw: '朝向',
  statusMove: '移动控制',
  statusExpand: '展开',
  statusCollapse: '收起',
  statusForward: '前进',
  statusBackward: '后退',
  statusLeft: '左移',
  statusRight: '右移',
  statusEstop: '急停',
  statusMoving: '正在{dir}...',
  statusMoveDisabledHint: '方向控制已禁用，可使用急停',
  statusMoveHint: '按住方向键移动，松开停止',
  statusMoveFailed: '移动控制失败',
  statusEstopSent: '急停指令已发送',
  statusEstopFailed: '急停失败',
  statusBack: '返回',
  timesUnit: '次',

  // 摄像头
  cameraTitle: '摄像头直播',
  cameraLeftWrist: '左手腕',
  cameraHead: '头部',
  cameraRightWrist: '右手腕',
  cameraSignalLost: '信号中断',
  cameraStreamUnconfigured: '未配置流地址',
  cameraStreamFailed: '拉流失败',
  cameraFullscreen: '全屏',
  cameraClose: '关闭',
  cameraLoading: '加载中...',

  // 地图
  mapTitle: '地图导航',
  mapView2d: '2D 栅格',
  mapLegendCurrent: '当前位置',
  mapLegendPath: '行驶轨迹',
  mapLegendStation: '点位',
  mapLegendTarget: '目标点位',
  mapLoadingTitle: '正在加载地图',
  mapLoadingHint: '正在获取设备栅格地图数据…',
  map25dOccupancy: '占据图',
  map25dTrail: '轨迹',
  map25dLabels: '标签',
  map25dLoading: '正在加载 2.5D 地图…',
  map25dUnsupported: '暂无该设备的 2.5D 地图',
  map25dUnsupportedHint: 'SN：{sn} · 请在 map25d/robots 下新增对应机器人地图',
  map25dLabelCartonRack: '双层纸箱架 · 195 × 90 cm',
  map25dLabelBasketRack: '整库料筐架 · 350 × 110 cm',
  map25dLabelMaterialShelf: '物料货架',

  // 工单池
  workOrderPool: '工单池',
  orderUnit: '{n} 单',
  statusNew: '新接到',
  statusPending: '排队中',
  statusInProgress: '进行中',
  statusCompleted: '已完成',
  statusUnknown: '未知',
  traysUnit: '盘',
  traysProgress: '{delivered}/{total} 盘',

  // 工单详情
  workOrderDetail: '工单详情',
  workOrderRoute: '路径',
  workOrderTrays: '托盘',
  workOrderEvents: '执行过程',
  workOrderNoEvents: '暂无执行记录',
  workOrderNotFound: '未找到工单',

  // 作业智能体
  agentTitle: '作业智能体',
  agentEmpty: '等待作业事件...',
  agentLive: '实时',
  agentConnecting: '连接中',
  agentConnected: '已连接',
  agentDisconnected: '已断开',
  agentLatest: '最新',
  agentStatusUpdate: '状态更新',
  agentNextStep: '下一步：',
  itemsUnit: '件',
  decisionLabel: '决策',

  // 布局
  splitAriaLabel: '调整工单池与作业智能体高度',
}
